<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2023-06-09 10:59:43
 * @LastEditTime: 2023-11-20 10:56:51
 * @LastEditors: WangYuhan
-->
<template>
  <div id="app">
    <router-view />
    <bulletinBoard :dialogVisible="isbulletinBoard" @handClose="handClose" />
  </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import bulletinBoard from './views/index/components/bulletin_board.vue';
import { listDisplayableNotifications, acknowledgedNotification } from '@/api/home';
import { configurationDetail } from '@/api/common';
import { getCookie } from '@/utils/cookie';
import { getToken } from '@/utils/auth';

export default {
  name: 'App',
  components: { bulletinBoard },
  data() {
    return {
      isbulletinBoard: false,
      fromRoute: '',
      bulletinData: [],
      cookie: '',
      intervalId: null,
    };
  },
  watch: {
    cookie(val) {
      const route = localStorage.getItem('route') ? true : false;
      if (val && route) {
        this.getlistDisplayableNotifications();
      }
    },
  },
  created() {
    console.log(!!getToken());
    if (getToken()) {
      this.intervalId = setInterval(() => {
        this.checkFirstVisit();
      }, 1800000);
    }

    this.cookie = getCookie('oss-token') ? getCookie('oss-token') : '';
    this.getUniqueCode();
    if (localStorage.userInfo) {
      if (!JSON.stringify(localStorage.userInfo).includes('groupId')) {
        // 清除状态保持
        window.localStorage.clear();
        // 状态保持清除后刷新页面
        window.location.reload();
      }
    }
  },
  destroyed() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  beforeDestroy() {
    this.$bus.$off('routeFrom');
  },
  methods: {
    //检查是够第一次访问
    checkFirstVisit() {
      const today = new Date().toDateString();
      const lastVisitDate = localStorage.getItem('lastVisitDate');
      if (lastVisitDate !== today) {
        this.getNewVersion();
      }
    },
    // 检查版本变化
    async getNewVersion() {
      var version = '';
      const lastVersion = localStorage.getItem('lastVersion');
      const { code, data } = await configurationDetail({ name: 'LASTEST_RELEASE_VERSION' });
      if (code === 200) {
        version = data.value;
      }
      if (version !== lastVersion) {
        localStorage.setItem('lastVersion', version);
        localStorage.setItem('lastVisitDate', new Date().toDateString());
        window.location.reload();
      }
    },
    async getlistDisplayableNotifications() {
      const { data } = await listDisplayableNotifications();
      if (data && data.length) {
        this.bulletinData = data.filter(item => {
          return item.type == 'ANNOUNCEMENT_WEB';
        });
      }
      if (this.bulletinData && this.bulletinData.length) {
        this.isbulletinBoard = true;
      } else {
        this.isbulletinBoard = false;
      }
    },
    async handClose() {
      const { code } = await acknowledgedNotification({
        userNotificationId: this.bulletinData[0].userNotificationId,
      });
      if (code == 200) {
        this.isbulletinBoard = false;
      }
    },
    //获取设备唯一标识
    getUniqueCode() {
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          const { visitorId } = result;
          localStorage.setItem('visitorId', visitorId);
        });
      });
    },
  },
};
</script>
